import { MenuItemDefinition } from '@neos/core'

export const menuItems: Record<string, MenuItemDefinition> = {
  Account: {
    icon: 'roleUsers',
    to: 'AccountUI',
  },
  AssignPermission: {
    to: 'AssignPermissionToRolesListUI',
  },
  Authorization: {
    icon: 'licenses',
    to: 'AuthorizationUI',
  },
  AuthorizationEditing: {
    icon: 'addLicense',
    to: 'AuthorizationEditingUI',
  },
  Country: {
    to: 'CountryLookupUI',
  },
  Currency: {
    to: 'CurrencyLookupUI',
  },
  EventLog: {
    to: 'EventLogUI',
  },
  EvoEnterprises: {
    icon: 'enterprises',
    to: 'EvoEnterprisesUI',
  },
  Municipality: {
    to: 'MunicipalityLookupUI',
  },
  NeosDataImport: {
    to: 'NeosDataImportTemplateEditUI',
  },
  Permission: {
    to: 'PermissionUI',
  },
  ProductsEditing: {
    icon: 'productEditing',
    to: 'ProductEditingUI',
  },
  ProvinceState: {
    to: 'ProvinceStateLookupUI',
  },
  Settings: {
    icon: 'general_settings',
    to: 'SettingUI',
  },
  SoftwareDownloadLink: {
    icon: 'softwareDownload',
    to: 'SoftwareDownloadLinkUI',
  },
  Statistics: {
    icon: 'excel',
    to: 'StatisticsUI',
  },
  Synchronization: {
    icon: 'syncBlack',
    to: 'SynchronizationUI',
  },
  UserAccount: {
    to: 'UserAccountListUI',
  },
  UserAccountUserRole: {
    to: 'UserAccountUserRoleUI',
  },
  UserSettings: {
    to: 'UserSettingsUI',
  },
  UserTenant: {
    icon: 'tenant',
    to: 'UserTenantListUI',
  }
}